import React from 'react';

export default class Page7 extends React.Component {

    render() {

        const {pageData} = this.props;

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">


                                <div className="ilead-rgt people">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Step 2: Scoring the self-analysis
                                                questionnaire
                                            </div>
                                            <p>Use the following process to score your results. Look at each
                                                category and add up the
                                                corresponding ratings:</p>


                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport tablesrink people-bg-none"
                                                   align="center">
                                                <tbody>
                                                <tr>
                                                    <th width="25%" align="center">Area</th>
                                                    <th width="25%">Items to Add</th>
                                                    <th width="10%" align="center">Total</th>
                                                </tr>
                                                <tr className="assertive_alt_2">
                                                    <td>
                                                        <div align="left">Quality</div>
                                                    </td>
                                                    <td>
                                                        <div align="left">1,6,11,16</div>
                                                    </td>
                                                    <td align="center">
                                                        {(pageData?.Item1 || 0) + (pageData?.Item6 || 0) + (pageData?.Item11 || 0) + (pageData?.Item16 || 0)}
                                                    </td>
                                                </tr>
                                                <tr className="assertive_alt_1">
                                                    <td>
                                                        <div align="left">Integrity</div>
                                                    </td>
                                                    <td>
                                                        <div align="left">2,7,12,17</div>
                                                    </td>
                                                    <td align="center">
                                                        {(pageData?.Item2 || 0) + (pageData?.Item7 || 0) + (pageData?.Item12 || 0) + (pageData?.Item17 || 0)}
                                                    </td>
                                                </tr>
                                                <tr className="assertive_alt_2">
                                                    <td>
                                                        <div align="left">Success</div>
                                                    </td>
                                                    <td>
                                                        <div align="left">3,8,13,18</div>
                                                    </td>
                                                    <td align="center">
                                                        {(pageData?.Item3 || 0) + (pageData?.Item8 || 0) + (pageData?.Item13 || 0) + (pageData?.Item18 || 0)}
                                                    </td>
                                                </tr>
                                                <tr className="assertive_alt_1">
                                                    <td>
                                                        <div align="left">Positive behaviour</div>
                                                    </td>
                                                    <td>
                                                        <div align="left">4,9,14,19</div>
                                                    </td>
                                                    <td align="center">
                                                        {(pageData?.Item4 || 0) + (pageData?.Item9 || 0) + (pageData?.Item14 || 0) + (pageData?.Item19 || 0)}
                                                    </td>
                                                </tr>
                                                <tr className="assertive_alt_2">
                                                    <td>
                                                        <div align="left">Visibility</div>
                                                    </td>
                                                    <td>
                                                        <div align="left">5,10,15,20</div>
                                                    </td>
                                                    <td align="center">
                                                        {(pageData?.Item5 || 0) + (pageData?.Item10 || 0) + (pageData?.Item15 || 0) + (pageData?.Item20 || 0)}
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            <div className="border_subtitle">Step 3: Consider your strengths and
                                                development needs
                                            </div>
                                            <p>Look up the one or two categories where you have the lowest score
                                                to find out your main
                                                approach to role modelling:
                                            </p>

                                            <div className="border_subtitle">Personality – Learning styles
                                                matrix:
                                            </div>


                                            <div className="desktop ipad-portrait-show">
                                                <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                       className="ilead_v_sport tablesrink para-bottompad sept">
                                                    <tbody>
                                                    <tr>
                                                        <th width="30%" align="left" valign="center"
                                                            className="green_curve">Area
                                                        </th>
                                                        <th width="35%" align="left" valign="top">Your Approach
                                                            to Role Modelling
                                                        </th>
                                                        <th width="40%" align="left" valign="top"
                                                            className=" green_curve1">Considerations
                                                        </th>


                                                    </tr>

                                                    <tr>
                                                        <td width="30%" align="left" valign="center"
                                                            className="lightgreen ">
                                                            <div className="">Quality</div>
                                                        </td>

                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen "><p>You focus your approach
                                                            on
                                                            ensuring that you hit the highest
                                                            possible levels. This approach
                                                            often links to integrity – if you
                                                            have high standards as a core
                                                            value then you are likely to try
                                                            and meet these goals.</p>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen "><p>Consider what success
                                                            looks like
                                                            for you and how you set about
                                                            showing the positive behaviours
                                                            which demonstrate to others
                                                            exactly how you reach those
                                                            peaks. Think as well about how
                                                            visible you are in showing how
                                                            you work to your high standards
                                                            and therefore how others can
                                                            learn from your approach.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="30%" align="left" valign="center"
                                                            className="darkgreen ">
                                                            <div className="">Integrity</div>
                                                        </td>

                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen "><p>Your approach centres on
                                                            ensuring that you behave
                                                            according to a set of personal/
                                                            organisational values. This will
                                                            often link in with positive
                                                            behaviours that you want to
                                                            display and may be linked to
                                                            having high standards.</p>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen "><p>Consider whether you are
                                                            showing others the attitude and
                                                            behaviours with which you are
                                                            trying to conduct yourself. Do
                                                            people know how your approach
                                                            will help you, and them, to
                                                            succeed?</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="30%" align="left" valign="center"
                                                            className="lightgreen ">
                                                            <div className="">Success</div>
                                                        </td>

                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen "><p>Success and reward is a
                                                            key
                                                            driver for you and you are likely
                                                            to judge your effectiveness on
                                                            your output. You are likely to
                                                            have a focus on achieving the
                                                            end goal and direct your actions
                                                            and behaviours accordingly.</p>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen "><p>Consider how much you
                                                            take
                                                            your approach into account.
                                                            Other people may be more
                                                            concerned about the approach
                                                            you take to achieve success as
                                                            well as the outcome itself, i.e. are
                                                            you being ethical? Do you
                                                            consider the people you work
                                                            with? Also, how much do you
                                                            publicise your success?</p>
                                                        </td>
                                                    </tr>

                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="mobile ipad-portrait-hide">
                                                <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                       className="ilead_v_sport tablesrink para-bottompad">


                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve" width="50%">Area</th>
                                                        <td className=" green_curve2">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Quality</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">Your Approach to Role
                                                            Modelling
                                                        </td>
                                                        <td valign="top">
                                                            <ul className="greenbullet-list">
                                                                <p>You focus your approach on
                                                                    ensuring that you hit the highest
                                                                    possible levels. This approach
                                                                    often links to integrity – if you
                                                                    have high standards as a core
                                                                    value then you are likely to try
                                                                    and meet these goals.</p>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg"
                                                            id="m-border-radius">Considerations
                                                        </td>
                                                        <td valign="top" id="m-border-light">
                                                            <p>Consider what success looks like
                                                                for you and how you set about
                                                                showing the positive behaviours
                                                                which demonstrate to others
                                                                exactly how you reach those
                                                                peaks. Think as well about how
                                                                visible you are in showing how
                                                                you work to your high standards
                                                                and therefore how others can
                                                                learn from your approach.</p>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th className="green_curve" width="50%">Area</th>
                                                        <td className=" green_curve1">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Integrity</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">Your Approach to Role
                                                            Modelling
                                                        </td>
                                                        <td valign="top" className="darkgreen">
                                                            <p>Your approach centres on
                                                                ensuring that you behave
                                                                according to a set of personal/
                                                                organisational values. This will
                                                                often link in with positive
                                                                behaviours that you want to
                                                                display and may be linked to
                                                                having high standards.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg"
                                                            id="m-border-radius">Considerations
                                                        </td>
                                                        <td valign="top" id="m-border-right">
                                                            <p>Consider whether you are
                                                                showing others the attitude and
                                                                behaviours with which you are
                                                                trying to conduct yourself. Do
                                                                people know how your approach
                                                                will help you, and them, to
                                                                succeed?</p>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <th className="green_curve" width="50%">Area</th>
                                                        <td className=" green_curve2">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Success</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">Your Approach to Role
                                                            Modelling
                                                        </td>
                                                        <td valign="top">
                                                            <ul className="greenbullet-list">
                                                                <p>Success and reward is a key driver for you
                                                                    and you are likely to judge your
                                                                    effectiveness on your output. You are likely
                                                                    to have a focus on achieving the end goal
                                                                    and direct your actions and behaviours
                                                                    accordingly.</p>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg"
                                                            id="m-border-radius">Considerations
                                                        </td>
                                                        <td valign="top" id="m-border-light">
                                                            <p>Consider how much you take your approach into
                                                                account. Other people may be more concerned
                                                                about the approach you take to achieve success
                                                                as well as the outcome itself, i.e. are you
                                                                being ethical? Do you consider the people you
                                                                work with? Also, how much do you publicise your
                                                                success?</p>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page8')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}